import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '@/state/store/auth';
import { useActiveOrganization } from '@/graphql/queries/organizations';
import { useGetTemplateById } from '@/modules/templates/hooks/use-templates';
import { EditOrgTemplateForm } from '../components/edit-org-template-form';
import { useEffect } from 'react';

const OrgTemplateEditPage = () => {
  const { orgId: orgSlug, id } = useParams<{ orgId: string; id: string }>();
  const navigate = useNavigate();
  const activeOrgRole = useAuthStore((state) => state.activeOrgRole);
  const { data: org, isLoading: isOrgLoading } = useActiveOrganization();
  const { data: template, isLoading: isTemplateLoading } = useGetTemplateById(id);

  useEffect(() => {
    if (activeOrgRole !== null && activeOrgRole !== 'org_admin' && activeOrgRole !== 'org_editor') {
      navigate(`/org/${orgSlug}`, { replace: true });
    }
  }, [activeOrgRole, orgSlug, navigate]);

  useEffect(() => {
    if (!isTemplateLoading && org && template === null) {
      navigate(`/org/${orgSlug}/templates`, { replace: true });
    }
  }, [isTemplateLoading, org, template, orgSlug, navigate]);

  if (isOrgLoading || isTemplateLoading || !template || !org) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-globe-grey" />
      </div>
    );
  }

  return (
    <EditOrgTemplateForm
      orgSlug={orgSlug ?? ''}
      orgId={org.BlocksOrgId}
      template={template}
      previewToken={template.previewToken}
    />
  );
};

export default OrgTemplateEditPage;
